import { Partners, PurchaseJourney } from 'utils/constants';

const getVehicleLabels = (purchaseJourney: PurchaseJourney | string) => {
    const isV1 = purchaseJourney === PurchaseJourney.V1;
    if (isV1) {
        return {
            label1: 'Vehicle Validation',
            label2: 'Select Model',
            placeholder: 'Search vehicle model',
        };
    }
    return {
        label1: 'Select vehicle',
        label2: 'Search vehicle',
        placeholder: 'Search vehicle model',
    };
};

export const getLabels = (
    partner: Partners | string,
    purchaseJourney: PurchaseJourney | string
) => {
    const { label1, label2, placeholder } = getVehicleLabels(purchaseJourney);
    switch (partner) {
        default:
            return {
                label1,
                label2,
                placeholder,
            };
    }
};
